<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab" @change="change">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="tab1">承运人订单</vxe-radio>
          </li>
          <li>
            <vxe-radio name="xtabs" label="tab2">实际供应方订单</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="search-box">
        <vxe-input
            v-model="sellerOrderNum"
            type="search"
            placeholder="订单号"
            @keyup.enter.native="search"
            @search-click="search"
            style="margin-right: 10px; border: 1px solid #dcdee2"
        ></vxe-input>
        <vxe-input
            style="margin-right: 10px; border: 1px solid #dcdee2"
            v-model="contractTitle"
            type="search"
            placeholder="订单标题"
            @keyup.enter.native="search"
            @search-click="search"
            class="choose-search-input"
        ></vxe-input>
        <vxe-input
            v-model="sellerName"
            type="search"
            placeholder="承运人名称"
            @keyup.enter.native="search"
            @search-click="search"
            style="border: 1px solid #dcdee2"
        ></vxe-input>
      </div>
    </div>
    <div v-show="selectTab === 'tab1'">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          ref="xTable1"
          class="table-style"
          max-height="400"
          align="center"
          :auto-resize="true"
          border="none"
          :data="sellerData"
          :loading="loading1"
          @current-change="currentChangeEvent1"
      >
        <vxe-table-column
            field="sellerOrdersNum"
            title="子订单编号"
            width="140"
        ></vxe-table-column>
        <vxe-table-column
            field="contractTitle"
            title="订单标题"
            width="120"
        ></vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人名称"
            width="240"
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人名称"
            width="240"
        ></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="120">
          <template slot-scope="{ row, $rowIndex }">
            <span v-if="row.goodsRtnVos">{{ row.goodsName }}</span>
            <Icon
                type="ios-arrow-down"
                @click.stop="clickEvent3($rowIndex)"
                v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
            />
            <vxe-pulldown :ref="$rowIndex" placement="bottom" transfer>
              <template v-slot:dropdown>
                <div class="my-dropdown3">
                  <vxe-table
                      auto-resize
                      style="width: 870px"
                      :data="row.goodsRtnVos"
                      stripe
                      show-overflow
                      align="center"
                  >
                    <vxe-table-column
                        field="goodsName"
                        title="货名"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="rule"
                        title="规格"
                        width="60"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="unit"
                        title="单位"
                        width="60"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="counts"
                        title="数量"
                        width="60"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="price"
                        title="单价"
                        width="60"
                    ></vxe-table-column>
                    <vxe-table-column field="isTax" title="含税" width="60">
                      <template slot-scope="{ row }">
                        <span>{{ row.isTax | taxMap }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="carShipNum"
                        title="车船号"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginPlace"
                        title="起运地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="endPlace"
                        title="到达地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="deliveryPoints"
                        title="交货地点"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
                      <template slot-scope="{ row }">
                        <span>{{ row.beginTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                  </vxe-table>
                </div>
              </template>
            </vxe-pulldown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="rule" title="规格" width="100"></vxe-table-column>
        <vxe-table-column field="unit" title="单位" width="60"></vxe-table-column>
        <vxe-table-column field="counts" title="数量" width="60"></vxe-table-column>
        <vxe-table-column field="price" title="单价" width="100"></vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="60">
          <template slot-scope="{ row }">
            <span>{{ row.isTax | taxMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="90"></vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="90"></vxe-table-column>
        <vxe-table-column field="endPlace" title="到达地" width="90"></vxe-table-column>
        <vxe-table-column field="deliveryPoints" title="交货地点" width="90"></vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page1.currentPage"
          :page-size.sync="page1.pageSize"
          :total="page1.totalResult"
          @page-change="changePage1"
      ></vxe-pager>
    </div>
    <div v-show="selectTab === 'tab2'">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          ref="xTable2"
          class="table-style"
          max-height="400"
          align="center"
          :auto-resize="true"
          border="none"
          :data="sellerData2"
          :loading="loading2"
          @current-change="currentChangeEvent2"
      >
        <vxe-table-column
            field="sellerOrdersNum"
            title="子订单编号"
            width="140"
        ></vxe-table-column>
        <vxe-table-column
            field="contractTitle"
            title="订单标题"
            width="120"
        ></vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人名称"
            width="240"
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人名称"
            width="240"
        ></vxe-table-column>
        <vxe-table-column
            field="platformCompany"
            title="平台企业"
            width="240"
        ></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="120">
          <template slot-scope="{ row, $rowIndex }">
            <span v-if="row.goodsRtnVos">{{ row.goodsName }}</span>
            <Icon
                type="ios-arrow-down"
                @click.stop="clickEvent3($rowIndex + 'Lv2')"
                v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
            />
            <vxe-pulldown :ref="$rowIndex + 'Lv2'" placement="bottom" transfer>
              <template v-slot:dropdown>
                <div class="my-dropdown3">
                  <vxe-table
                      auto-resize
                      style="width: 870px"
                      :data="row.goodsRtnVos"
                      stripe
                      show-overflow
                      max-height="480"
                      align="center"
                  >
                    <vxe-table-column
                        field="goodsName"
                        title="货名"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="rule"
                        title="规格"
                        width="60"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="unit"
                        title="单位"
                        width="60"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="counts"
                        title="数量"
                        width="60"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="price"
                        title="单价"
                        width="60"
                    ></vxe-table-column>
                    <vxe-table-column field="isTax" title="含税" width="60">
                      <template slot-scope="{ row }">
                        <span>{{ row.isTax | taxMap }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="carShipNum"
                        title="车船号"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginPlace"
                        title="起运地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="endPlace"
                        title="到达地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="deliveryPoints"
                        title="交货地点"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginTime"
                        title="受载/起运时间"
                        width="120"
                    >
                      <template slot-scope="{ row }">
                        <span>{{ row.beginTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                  </vxe-table>
                </div>
              </template>
            </vxe-pulldown>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="rule"
            title="规格"
            width="100"
        ></vxe-table-column>
        <vxe-table-column
            field="unit"
            title="单位"
            width="60"
        ></vxe-table-column>
        <vxe-table-column
            field="counts"
            title="数量"
            width="60"
        ></vxe-table-column>
        <vxe-table-column
            field="price"
            title="单价"
            width="100"
        ></vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="60">
          <template slot-scope="{ row }">
            <span>{{ row.isTax | taxMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="carShipNum"
            title="车船号"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="beginPlace"
            title="起运地"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="endPlace"
            title="到达地"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="deliveryPoints"
            title="交货地点"
            width="90"
        ></vxe-table-column>
        <vxe-table-column
            field="beginTime"
            title="受载/起运时间"
            width="120"
        >
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="createUser"
            title="创建人"
            width="90"
        ></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page2.currentPage"
          :page-size.sync="page2.pageSize"
          :total="page2.totalResult"
          @page-change="changePage2"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import Auth from "@/utils/auth.js";

  export default {
    name: "ChooseRelationOrder",
    props: ["orderId"],
    data() {
      let userInfoValue = {};
      if (Auth.isLogin()) {
        userInfoValue = Auth.getAuth();
      }
      return {
        userInfoValue,
        sellerOrderNum: null,
        sellerName: null,
        contractTitle: null,
        selectTab: "tab1",
        loading1: false,
        loading2: false,
        sellerData: [],
        sellerData2: [],
        page1: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        page2: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
      };
    },
    methods: {
      init() {
        this.page1 = {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        };
        this.page2 = {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        };
        this.sellerOrderNum = null;
        this.sellerName = null;
        this.querySellerOrder();
        this.querySecSellerOrder();
      },
      change() {
        this.contractTitle = null;
        this.sellerOrderNum = null;
        this.sellerName = null;
      },
      changePage1(e) {
        this.page1.currentPage = e.currentPage;
        this.page1.pageSize = e.pageSize;
        this.querySellerOrder();
      },
      changePage2(e) {
        this.page2.currentPage = e.currentPage;
        this.page2.pageSize = e.pageSize;
        this.querySecSellerOrder();
      },
      clickEvent3(id) {
        this.$refs[id].togglePanel();
      },
      currentChangeEvent1({row}) {
        this.$emit("choose", row, "ordersSellerId");
      },
      currentChangeEvent2({row}) {
        this.$emit("choose", row, "ordersSellerLv2Id");
      },
      search() {
        if (this.selectTab === "tab1") {
          this.page1.currentPage = 1;
          this.page1.pageSize = 10;
          this.querySellerOrder();
        } else {
          this.page2.currentPage = 1;
          this.page2.pageSize = 10;
          this.querySecSellerOrder();
        }
      },
      close() {
        this.$refs.xTable1.clearCurrentRow();
        this.$refs.xTable2.clearCurrentRow();
      },
      async querySellerOrder() {
        // 获取列表数据
        this.loading1 = true;
        let path =
          this.userInfoValue.identityType === 0
            ? "queryOrdersSellerList"
            : "queryOrdersSellerListWithoutPermission";

        let res = await $api.ordersSeller.post(path, {
          contractTitle: this.contractTitle,
          sellerOrderNum: this.sellerOrderNum,
          sellerName: this.sellerName,
          isSecondSeller: 0,
          page: this.page1.currentPage,
          rows: this.page1.pageSize,
          orderBy: 2,
          chainId: this.orderId ? this.orderId : null,
          orderType: 0
        });

        if (res) {
          this.page1.totalResult = res.data.total;
          let sellerData = res.data.rows;
          sellerData.map((i) => {
            if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
              i.goodsName = i.goodsRtnVos[0].goodsName;
              i.rule = i.goodsRtnVos[0].rule;
              i.unit = i.goodsRtnVos[0].unit;
              i.counts = i.goodsRtnVos[0].counts;
              i.price = i.goodsRtnVos[0].price;
              i.isTax = i.goodsRtnVos[0].isTax;
              i.carShipNum = i.goodsRtnVos[0].carShipNum;
              i.beginPlace = i.goodsRtnVos[0].beginPlace;
              i.endPlace = i.goodsRtnVos[0].endPlace;
              i.beginTime = i.goodsRtnVos[0].beginTime;
              i.createTime = i.goodsRtnVos[0].createTime;
              i.deliveryPoints = i.goodsRtnVos[0].deliveryPoints;
              i.transportationType = i.goodsRtnVos[0].transportationType;
              i.carshipId = i.goodsRtnVos[0].carshipId;
            }
          });
          this.sellerData = sellerData;
          this.loading1 = false;
        }

        // $api.order.queryOrdersSellerListWithoutPermission
        //   .POST({
        //     data: {
        //       sellerOrderNum: this.sellerOrderNum,
        //       sellerName: this.sellerName,
        //       isSecondSeller: 0,
        //       page: this.page1.currentPage,
        //       rows: this.page1.pageSize,
        //       orderBy: 2,
        //       chainId: this.orderId ? this.orderId : null,
        //     },
        //   })
        //   .then((res) => {
        //     this.page1.totalResult = res.data.total;
        //     let sellerData = res.data.rows;
        //     sellerData.map((i) => {
        //       if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
        //         i.goodsName = i.goodsRtnVos[0].goodsName;
        //         i.rule = i.goodsRtnVos[0].rule;
        //         i.unit = i.goodsRtnVos[0].unit;
        //         i.counts = i.goodsRtnVos[0].counts;
        //         i.price = i.goodsRtnVos[0].price;
        //         i.isTax = i.goodsRtnVos[0].isTax;
        //         i.carShipNum = i.goodsRtnVos[0].carShipNum;
        //         i.beginPlace = i.goodsRtnVos[0].beginPlace;
        //         i.endPlace = i.goodsRtnVos[0].endPlace;
        //         i.beginTime = i.goodsRtnVos[0].beginTime;
        //         i.createTime = i.goodsRtnVos[0].createTime;
        //         i.deliveryPoints = i.goodsRtnVos[0].deliveryPoints;
        //         i.transportationType = i.goodsRtnVos[0].transportationType;
        //       }
        //     });
        //     this.sellerData = sellerData;
        //     this.loading1 = false;
        //   });
      },
      async querySecSellerOrder() {
        // 获取列表数据
        this.loading2 = true;
        let path =
          this.userInfoValue.identityType === 0
            ? "queryOrdersSellerList"
            : "queryOrdersSellerListWithoutPermission";

        let res = await $api.ordersSeller.post(path, {
          contractTitle: this.contractTitle,
          sellerOrderNum: this.sellerOrderNum,
          sellerName: this.sellerName,
          isSecondSeller: 1,
          page: this.page2.currentPage,
          rows: this.page2.pageSize,
          orderBy: 2,
          chainId: this.orderId ? this.orderId : null,
        });

        if (res) {
          this.page2.totalResult = res.data.total;
          let sellerData2 = res.data.rows;
          sellerData2.map((i) => {
            if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
              i.goodsName = i.goodsRtnVos[0].goodsName;
              i.rule = i.goodsRtnVos[0].rule;
              i.unit = i.goodsRtnVos[0].unit;
              i.counts = i.goodsRtnVos[0].counts;
              i.price = i.goodsRtnVos[0].price;
              i.isTax = i.goodsRtnVos[0].isTax;
              i.carShipNum = i.goodsRtnVos[0].carShipNum;
              i.beginPlace = i.goodsRtnVos[0].beginPlace;
              i.endPlace = i.goodsRtnVos[0].endPlace;
              i.beginTime = i.goodsRtnVos[0].beginTime;
              i.createTime = i.goodsRtnVos[0].createTime;
              i.deliveryPoints = i.goodsRtnVos[0].deliveryPoints;
              i.transportationType = i.goodsRtnVos[0].transportationType;
              i.carshipId = i.goodsRtnVos[0].carshipId;
            }
          });
          this.sellerData2 = sellerData2;
          this.loading2 = false;
        }

        // $api.order.queryOrdersSellerListWithoutPermission
        //   .POST({
        //     data: {
        //       sellerOrderNum: this.sellerOrderNum,
        //       sellerName: this.sellerName,
        //       isSecondSeller: 1,
        //       page: this.page2.currentPage,
        //       rows: this.page2.pageSize,
        //       orderBy: 2,
        //       chainId: this.orderId ? this.orderId : null,
        //     },
        //   })
        //   .then((res) => {
        //     this.page2.totalResult = res.data.total;
        //     let sellerData2 = res.data.rows;
        //     sellerData2.map((i) => {
        //       if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
        //         i.goodsName = i.goodsRtnVos[0].goodsName;
        //         i.rule = i.goodsRtnVos[0].rule;
        //         i.unit = i.goodsRtnVos[0].unit;
        //         i.counts = i.goodsRtnVos[0].counts;
        //         i.price = i.goodsRtnVos[0].price;
        //         i.isTax = i.goodsRtnVos[0].isTax;
        //         i.carShipNum = i.goodsRtnVos[0].carShipNum;
        //         i.beginPlace = i.goodsRtnVos[0].beginPlace;
        //         i.endPlace = i.goodsRtnVos[0].endPlace;
        //         i.beginTime = i.goodsRtnVos[0].beginTime;
        //         i.createTime = i.goodsRtnVos[0].createTime;
        //         i.deliveryPoints = i.goodsRtnVos[0].deliveryPoints;
        //         i.transportationType = i.goodsRtnVos[0].transportationType;
        //       }
        //     });
        //     this.sellerData2 = sellerData2;
        //     this.loading2 = false;
        //   });
      },
    },
  };
</script>

<style scoped>
  .btn-down {
    border: none;
    background: transparent;
  }

  .btn-down:focus {
    outline: none;
    border-color: transparent;
    box-shadow: none;
  }
</style>